import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFedex = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "#660099"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25.5748 19.3138L24.6215 18.2448L23.6771 19.3138H21.6901L23.632 17.1311L21.6901 14.9483H23.7393L24.7016 16.0086L25.6282 14.9483H27.6058L25.6727 17.122L27.6329 19.3138H25.5748ZM17.8721 19.3138V12.4365H21.6901V13.9696H19.489V14.9483H21.6901V16.4229H19.489V17.7767H21.6901V19.3138H17.8721Z",
			fill: "#FF6600"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2622 12.4365V15.2511H16.2439C15.8875 14.8412 15.4422 14.6988 14.9255 14.6988C13.8581 14.6988 13.0649 15.4341 12.7916 16.3975C12.4772 15.3351 11.6557 14.679 10.4257 14.679C9.42701 14.679 8.64909 15.1368 8.2428 15.8717V14.9482H6.19365V13.9694H8.4301V12.4365H4.36646V19.3138H6.19365V16.4229H8.025C7.96981 16.6369 7.93128 16.8605 7.93128 17.1028C7.93128 18.5374 9.02682 19.5443 10.4257 19.5443C11.6022 19.5443 12.3773 18.9919 12.7874 17.9852H11.2218C11.0101 18.2882 10.8491 18.3775 10.4256 18.3775C9.93476 18.3775 9.51151 17.9495 9.51151 17.4414H12.7083C12.8474 18.5799 13.7257 19.5636 14.9432 19.5636C15.4689 19.5636 15.9501 19.3056 16.2439 18.8689H16.2622V19.314H17.8722V12.4365H16.2622ZM9.56254 16.4435C9.66385 16.0065 10.0026 15.7213 10.4256 15.7213C10.8915 15.7213 11.213 15.9982 11.2975 16.4435H9.56254ZM15.2845 18.2669C14.6909 18.2669 14.3221 17.7135 14.3221 17.1364C14.3221 16.519 14.6427 15.9254 15.2845 15.9254C15.9501 15.9254 16.2148 16.519 16.2148 17.1364C16.2148 17.7217 15.9339 18.2669 15.2845 18.2669Z",
			fill: "white"
		})
	]
});
export default SvgFedex;
